import { render, staticRenderFns } from "./ArticuloCard.vue?vue&type=template&id=1210fe38&scoped=true&"
import script from "./ArticuloCard.vue?vue&type=script&lang=js&"
export * from "./ArticuloCard.vue?vue&type=script&lang=js&"
import style0 from "./ArticuloCard.vue?vue&type=style&index=0&id=1210fe38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1210fe38",
  null
  
)

export default component.exports